import { Grid, TextButton } from '@tfo/common'
import { inject } from 'mobx-react'
import * as React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { useHistory } from 'react-router-dom'
import IndividualHeader from '../../common/individual-header/IndividualHeader'
import { WithdrawnViewModel } from '../../ViewModels'

import './Withdrawn.scss'

const { GridWrapper } = Grid

type WithdrawnProps  = WithdrawnViewModel

const Withdrawn: React.FunctionComponent<WithdrawnProps &
	WrappedComponentProps> = props => {
	const {declined, companyName, orderId} = props
	const history = useHistory()

	return (
		<React.Fragment>
			<GridWrapper className="IndividualView Withdrawn">
				<IndividualHeader
					companyName={companyName}
					headingId="withdrawn.heading"
					preambleId="withdrawn.body"
					preambleData={{
						date: props.intl.formatDate(declined),
						time: props.intl.formatTime(declined),
						companyName: companyName,
					}}
					isIDD={false}
				/>

				<div className={'IndividualButtons'}>
					<TextButton
						onClick={() => {
							history.push(`/approval/${orderId}`)
						}}
						className="Withdrawn__TextButton Withdrawn__TextButton--left">
						{props.intl.formatMessage({ id: 'withdrawn.btn.change' })}
					</TextButton>
				</div>
			</GridWrapper>
		</React.Fragment>
	)
}

export default inject('rootStore')(injectIntl(Withdrawn))
